import {Injectable} from '@angular/core';
import {ApiClientService} from './api-client.service';
import {Notice} from '../types/data.types';
import {UrlService} from './url.service';
import {EmptyRowService} from './empty-row.service';
import {ConstantsService} from './constants.service';
import {EmailService} from './email.service';
import {Attachment} from "../types/email-data.types";

declare const toastr: any;
declare const swal: any;
declare const $: any;

@Injectable()
export class NoticesService {
    isNoticeModalShow = false;
    isNoticeWizardShow = false;
    isNoticeScheduleShow = false;
    isNoticeInfoShow = false;
    choosingTemplate = false;
    isChooseIconModalShow = false;
    wizardType = '';
    step = '';
    firstStep = '';
    noticeInNoticeModal: Notice;
    attachmentInViewAttachmentModal = null;
    isViewAttachmentModalShow = false;
    data = {
        allNotices: {
            get: '/v1/key_log.json?expand=building,suite,resident,incidentReportType,createdBy,activities',
            data: {notices: [], playlists: []},
            total: null
        },
    };
    tabId = 'notices';
    spinnerShow = true;
    buildings:    Array<any> = [];

    constructor(
        public api: ApiClientService,
        public urlService: UrlService,
        public emptyRowService: EmptyRowService,
    ) {
        this.api.onLogout.subscribe(() => this.buildings = []);
    }

    getData() {
        this.spinnerShow = true;
        this.data[this.tabId].total = null;

        const tabId       = this.urlService.queryParams['tab'];
        const url         = this.data[tabId].get;
        const queryParams = this.urlService.getQueryParamsString();

        // this.api.get('domainNotices', `${url}${queryParams}`).subscribe(
        //     (res) => {
        //         const body = JSON.parse(res._body);
        //         const body = [];
        //         const entities = body.entities;
        //         this.data[tabId].data = [];
        //         this.data[tabId].total = body.total;
        //         this.emptyRowService.fillEmptyRow();
        //         this.classifiedsFactory(entities, this.data[tabId].data);
        //         this.spinnerShow = false;
        //     },
        //     (error) => this.api.errorHandler(error, 'Failed to get Notices')
        // );

        ///

        const entities = [{
            id:208,
            title:"",
            content:"",
            pdf:false,
            categoryId:0,
            createdBy:3,
            createdByUser:{
                id:0,
                login:"",
                firstname:"",
                lastname:"",
                email:"",
                accessLevel:"",
                createdBy:0,
                createdAt:"",
                updatedBy:0,
                updatedAt:"",
                deleted:false,
                deletedBy:0,
                deletedAt:"",
                active:false
            },
            createdAt:"2017-12-13 20:15:58",
            editedBy:3,
            editedAt:"2017-12-15 12:09:48",
            deleted:true,
            deletedBy:3,
            deletedAt:"2017-12-15 12:15:54",
            status:"archived",
            schedule:{
                activateFrom:"2017-12-13 20:17:00",
                activateTo:"0000-00-00 00:00:00",
                duration:15,
                hours:"",
                days:"",
                weekdays:"",
                month:"",
                deleted:false
            }
        }];
        // const entities = body.entities;
        this.data[tabId].data = [];
        this.data[tabId].total = entities.length;
        this.emptyRowService.fillEmptyRow();
        this.classifiedsFactory(entities, this.data[tabId].data);
        this.spinnerShow = false;
        ////
    }

    classifiedsFactory(entities: any, targetArray) {
        entities.forEach((not) => {
            const notice = new Notice();

            if (not.title           ) notice.title            = not.title;
            if (not.editedBy        ) notice.editedBy         = not.editedBy;
            if (not.deletedBy       ) notice.deletedBy        = not.deletedBy;
            if (not.id              ) notice.id               = not.id;
            if (not.deletedAt       ) notice.deletedAt        = not.deletedAt;
            if (not.editedAt        ) notice.editedAt         = not.editedAt;
            if (not.status          ) notice.status           = not.status;
            if (not.categoryId      ) notice.categoryId       = not.categoryId;
            if (not.createdByUser   ) notice.createdByUser    = not.createdByUser;
            if (not.createdAt       ) notice.createdAt        = not.createdAt;
            if (not.pdf             ) notice.pdf              = not.pdf;
            if (not.content         ) notice.content          = not.content;
            if (not.schedule        ) notice.schedule         = not.schedule;

            targetArray.push(notice);
        });
    }

    getBuildings(): void {
        if (this.buildings.length) return;
        const url = `/v1/buildings.json?per-page=1000&order-by=name|asc`;
        this.api.get('domainBD', url).subscribe(
            (res)   => this.buildings = JSON.parse(res._body).entities,
            (error) => this.api.errorHandler(error, 'Failed get buildings')
        );
    }

    resetData() {
        for (const item in this.data) {
            this.data[item].data = [];
            this.data[item].total = null;
        }
    }

    signOutKey(classified: Notice) {
        // this.signOutKeyModal   = true;
        this.noticeInNoticeModal = Object.assign({}, classified);
    }

    returnKey(classified: Notice) {
        // this.returnKeyModal   = true;
        this.noticeInNoticeModal = Object.assign({}, classified);
    }

    deleteKeyLog(classified: Notice): void {
        if (!classified.id) return;
        swal(ConstantsService.getSwalConfig('Delete Key Log'),
            () => {
                const url = `/v1/key_log/${classified.id}.json`;
                this.api.remove('domainClassifieds', url).subscribe(
                    () => {
                        toastr.success('Classified has been deleted.');
                        this.getData();
                    },
                    (error) => this.api.errorHandler(error, 'Delete Classified failed')
                );
            }
        );
    }

    getHistory(classified: Notice): void {
        // this.showHistoryModal = true;
        this.noticeInNoticeModal = Object.assign({}, classified);
    }

    showAttachment(attachment) {
        const attachmentAsObject = new Attachment(attachment.name, 0, attachment.path);
        if (attachmentAsObject.isImage()) {
            this.attachmentInViewAttachmentModal = attachmentAsObject;
            this.isViewAttachmentModalShow = true;
        }
    }

}



// WEBPACK FOOTER //
// /app/src/app/services/notices.service.ts